/**
 * Adapted from PlayCanvas Engine's gsplat-asset-loader-base.js at
 * d88289fb0c17be76ec4159974faf0d07d3582a6b (MIT License).
 */
import { getLoggerManager } from '@/shared/logging'
import type { Disposable } from '@/shared/types/core'

const log = getLoggerManager().getLogger('gsplat:asset-loader')

/**
 * 冻结 PlayCanvas runtime-compatible loader base。
 *
 * 这些方法刻意不是 abstract：未实现的子类仍应只记录诊断、不抛错、不产生副作用。
 */
export class GSplatAssetLoaderBase<TResource extends Disposable = Disposable>
  implements Disposable
{
  load(_url: string): void {
    log.error('GSplatAssetLoaderBase#load: Not implemented')
  }

  unload(_url: string): void {
    log.error('GSplatAssetLoaderBase#unload: Not implemented')
  }

  getResource(_url: string): TResource | undefined {
    log.error('GSplatAssetLoaderBase#getResource: Not implemented')
    return undefined
  }

  hasFailed(_url: string): boolean {
    return false
  }

  destroy(): void {}

  dispose(): void {
    this.destroy()
  }
}
